import { render, staticRenderFns } from "./LayoutAuthorized.vue?vue&type=template&id=0a788398&"
import script from "./LayoutAuthorized.vue?vue&type=script&lang=js&"
export * from "./LayoutAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAuthorized.vue?vue&type=style&index=0&id=0a788398&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports